__turbopack_context__.v({
  "badge": "TransportCard-module__fbt2BW__badge",
  "card": "TransportCard-module__fbt2BW__card",
  "compact": "TransportCard-module__fbt2BW__compact",
  "description": "TransportCard-module__fbt2BW__description",
  "header": "TransportCard-module__fbt2BW__header",
  "logo": "TransportCard-module__fbt2BW__logo",
  "subtitle": "TransportCard-module__fbt2BW__subtitle",
  "title": "TransportCard-module__fbt2BW__title",
});
